import { Form } from 'antd'
import { useEffect, useState} from 'react'
import WizrInput from '../WizrInput'
import WizrFlexSpacing from '../WizrFlexSpacing'
import WizrButton from '../WizrButton'
import WizrFlexLayout from '../WizrFlexLayout'
import { styled } from 'styled-components'
import { useContentLoadingSelector } from '../../redux/selectors/content'

const StyledContainer = styled(WizrFlexLayout)`
  gap: 8px;
`

interface ICreateGroup {
  groupName?: string
  onFormSubmission: (params: { [key: string]: any }) => void
  onCancel: () => void
}

const CreateGroup = ({
  groupName,
  onFormSubmission,
  onCancel,
}: ICreateGroup): JSX.Element => {
  const [form] = Form.useForm()
  const loading = useContentLoadingSelector()
  const [showFieldNameValidation, setShowFieldNameValidation] = useState(false)
  
  useEffect(() => {
    form.setFieldValue('currentGroupName', groupName)
  }, [groupName])
  
  const isBlank = (text?: string) => !text || text.trim() === ''

  const handleFinish = (values: any) => {
    if (isBlank(values.currentGroupName)) {
      setShowFieldNameValidation(true)
      return
    }
    setShowFieldNameValidation(false)
    onFormSubmission(values)
  }

  return (
    <StyledContainer background='#FFF' justifyContent='space-evenly'>
      <Form
        name='basic'
        form={form}
        initialValues={{ remember: true }}
        onFinish={handleFinish}
        onFinishFailed={() => null}
        autoComplete='off'
      >
        <Form.Item name='currentGroupName'>
          <WizrInput
            placeholder='Enter Group Name'
            required={true}
            showError={showFieldNameValidation}
            errorMessage='Group name is required'
            onChange={(value: string) => {
              form.setFieldsValue({ currentGroupName: value })
              if (showFieldNameValidation && !isBlank(value)) {
                setShowFieldNameValidation(false)
              }
            }}
          />
        </Form.Item>
       
        <Form.Item>
          <WizrFlexSpacing
            justifyContent='flex-end'
            flexDirection='row'
            size='large'
            background='#FFF'
          >
            <WizrButton type='default' text='Cancel' onClick={onCancel} style={{ borderRadius: '20px' }}/>
            <WizrButton htmlType='submit' text={groupName ? 'Update' : 'Create'} disabled={loading} style={{ borderRadius: '20px' }}/>
          </WizrFlexSpacing>
        </Form.Item>
      </Form>
    </StyledContainer>
  )
}

export default CreateGroup
